export class TravelService {
  async checkTravel(data) {
      const response = await fetch(`/api/checkTravel`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({travel: data})
        })
      return await response.json();
  }
}